import React from 'react';
import { Link } from 'react-router-dom';

export default function InfluencerMarketing() {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url('/images/services/influencer-marketing-detail.jpg')` }}
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Influencer Marketing</h1>
            <p className="text-xl mb-8">
              Leverage the power of trusted voices to amplify your brand message and reach new audiences.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-zolo-orange hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold mb-6">Authentic Connections, Real Results</h2>
            
            <p className="text-lg text-gray-700 mb-6">
              At Zolo Service, we help businesses in Chhindwara and across India harness the power of influencer marketing to build brand awareness, establish credibility, and drive conversions. Our strategic approach connects your brand with the right influencers who can authentically communicate your message to their engaged audiences.
            </p>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Influencer Marketing Services Include:</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Influencer Identification</h4>
                  <p className="text-gray-700">
                    Strategic selection of relevant influencers based on audience demographics, engagement rates, and brand alignment.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Campaign Strategy</h4>
                  <p className="text-gray-700">
                    Development of comprehensive influencer marketing strategies aligned with your business objectives.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Content Collaboration</h4>
                  <p className="text-gray-700">
                    Creative guidance and collaboration with influencers to produce authentic, engaging content.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Campaign Management</h4>
                  <p className="text-gray-700">
                    End-to-end management of influencer relationships, content approval, and campaign execution.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Performance Tracking</h4>
                  <p className="text-gray-700">
                    Comprehensive monitoring and reporting of campaign metrics, engagement, and ROI.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Long-term Partnerships</h4>
                  <p className="text-gray-700">
                    Development of ongoing influencer relationships for consistent brand advocacy and growth.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Types of Influencer Collaborations We Offer</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Sponsored Content</h4>
                  <p className="text-gray-700">
                    Paid posts featuring your products or services on influencer channels.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Brand Ambassadors</h4>
                  <p className="text-gray-700">
                    Long-term partnerships with influencers who consistently promote your brand.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Product Reviews</h4>
                  <p className="text-gray-700">
                    Honest reviews and demonstrations of your products by trusted influencers.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Event Promotion</h4>
                  <p className="text-gray-700">
                    Influencer attendance and coverage of your brand events or product launches.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Affiliate Marketing</h4>
                  <p className="text-gray-700">
                    Performance-based partnerships where influencers earn commission on sales they generate.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Content Co-creation</h4>
                  <p className="text-gray-700">
                    Collaborative content development with influencers for your brand channels.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12">
              <h3 className="text-2xl font-bold mb-4">Why Choose Our Influencer Marketing Services?</h3>
              
              <ul className="space-y-4 text-lg text-gray-700">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Strategic Influencer Selection:</strong> We identify influencers whose audience demographics and values align perfectly with your brand.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Authentic Partnerships:</strong> We focus on creating genuine connections that resonate with audiences rather than forced promotions.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Data-Driven Results:</strong> We track comprehensive metrics to measure campaign performance and optimize for maximum ROI.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Local & National Reach:</strong> We work with influencers at all levels, from local Chhindwara voices to national celebrities.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>End-to-End Management:</strong> We handle all aspects of the campaign from influencer selection to final reporting.</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden sticky top-24">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Ready to Leverage Influencers?</h3>
                <p className="mb-0">Contact us today for a free consultation and influencer strategy.</p>
              </div>
              
              <div className="p-6">
                <form className="space-y-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Email"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Phone</label>
                    <input 
                      type="tel" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Phone"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Industry</label>
                    <select 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                    >
                      <option value="">Select Your Industry</option>
                      <option value="fashion">Fashion & Apparel</option>
                      <option value="beauty">Beauty & Cosmetics</option>
                      <option value="food">Food & Beverage</option>
                      <option value="tech">Technology</option>
                      <option value="health">Health & Wellness</option>
                      <option value="travel">Travel & Hospitality</option>
                      <option value="education">Education</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Message</label>
                    <textarea 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      rows={4}
                      placeholder="Tell us about your influencer marketing goals"
                    ></textarea>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="w-full bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-md transition duration-300"
                  >
                    Get a Free Consultation
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
